import { IncludedExcludedCounter } from 'components/common/types/IncludedExcludedCounter.types';
import { POI } from 'components/common/types/Planner.types';
import { CUSTOM_POI_DATA_PROVIDER } from 'components/pages/Planner/PlannerSections/DataTargetingContent/PointsOfInterest/consts';

export interface GroupedPOI {
  included: POI[];
  excluded: POI[];
}

export const groupPOIByParentCategory = (selectedPOIs: POI[]): Record<string, GroupedPOI> => {
  return selectedPOIs.reduce<Record<string, GroupedPOI>>((groupedPOIs, poi) => {
    const { parentCategory, name, code, include, dataProvider } = poi;

    const categoryKey = parentCategory || (dataProvider === CUSTOM_POI_DATA_PROVIDER ? code : name);

    if (!groupedPOIs[categoryKey]) {
      groupedPOIs[categoryKey] = { included: [], excluded: [] };
    }

    groupedPOIs[categoryKey][include ? 'included' : 'excluded'].push(poi);

    return groupedPOIs;
  }, {});
};

export const countIncludedAndExcludedPOI = (selectedPOIs: POI[]): IncludedExcludedCounter => {
  return selectedPOIs.reduce(
    (counts, { include }) => {
      if (include) {
        counts.included++;
      } else {
        counts.excluded++;
      }
      return counts;
    },
    { included: 0, excluded: 0 },
  );
};
